<template>
  <component
    :is="component"
    v-bind="{ ...$props, ...$attrs }"
    v-on="$listeners"
  >
    <template v-for="slot in Object.keys($scopedSlots)" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </component>
</template>

<script>
import types from './../common/order-types';

export default {
  name: 'OrderCustomerDetails',
  components: {
    CustomerDetails: () => import('./CustomerDetails/CustomerDetails'),
    BusinessDetails: () => import('./CustomerDetails/BusinessDetails')
  },
  props: {
    type: {
      type: Number,
      required: true,
      validator: prop => Object.values(types).includes(prop)
    },
    customer: {
      type: Object,
      required: true
    },
    showTitle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    component() {
      switch (this.type) {
        case types.CUSTOMER:
        case types.REPETITIVE_CUSTOMER:
          return 'CustomerDetails';
        case types.BUSINESS:
        case types.INTERNAL:
        case types.REPETITIVE_BUSINESS:
          return 'BusinessDetails';
        default:
          throw new Error('Customer details type undefined!');
      }
    }
  }
};
</script>
